import { useQuery } from "@tanstack/react-query";
import autoMessageService from "..";
import { NotifierCustomerNotifierType } from "../request";

const useGetCheckNotifier = (check: NotifierCustomerNotifierType) =>
  useQuery({
    queryKey: ["check-notifier"],
    queryFn: () => autoMessageService.checkNotifierBalance(check),
    select: (res) => res,
  });

export { useGetCheckNotifier };
